module.exports = __webpack_public_path__ + "img/icon7.a6147580.png";